(function () {
  'use strict';
  if (window.__pgDeferredApps) return;
  var node = document.getElementById('pg-deferred-app-config');
  if (!node) return;
  var config;
  try { config = JSON.parse(node.textContent); } catch (_) { return; }
  window.__pgDeferredApps = true;
  var klaviyoId = /^[a-zA-Z0-9]{6}$/.test(config.klaviyo || '') ? config.klaviyo : '';
  var clarityId = /^[a-zA-Z0-9]+$/.test(config.clarity || '') ? config.clarity : '';
  var requested = {};
  function load(name, url) {
    if (requested[name]) return;
    if (Array.from(document.scripts).some(function (script) { return script.src === url; })) return;
    var script = document.createElement('script');
    requested[name] = true;
    script.async = true;
    script.src = url;
    script.addEventListener('error', function () {
      requested[name] = false;
      script.remove();
    }, { once: true });
    document.head.appendChild(script);
  }
  function loadKlaviyo() {
    if (klaviyoId) load('klaviyo', 'https://static.klaviyo.com/onsite/js/' + klaviyoId + '/klaviyo.js?company_id=' + klaviyoId);
  }
  if (klaviyoId) {
    window._klOnsite = window._klOnsite || [];
    window._learnq = window._learnq || [];
    if (!window.klaviyo) {
      var push = function () { return window._klOnsite.push.apply(window._klOnsite, arguments); };
      window.klaviyo = typeof Proxy === 'function' ? new Proxy({}, {
        get: function (_, method) {
          if (method === 'push') return push;
          return function () {
            var args = Array.from(arguments);
            var callback = typeof args[args.length - 1] === 'function' ? args.pop() : null;
            return new Promise(function (resolve) {
              window._klOnsite.push([method].concat(args, [function (result) {
                if (callback) callback(result);
                resolve(result);
              }]));
            });
          };
        }
      }) : { push: push };
    }
    if (config.customer && config.customer.email) window._klOnsite.push(['identify', config.customer]);
    window.klaviyoReviewsProductDesignMode = Boolean(window.Shopify && window.Shopify.designMode);
    if (config.product && !window.item) {
      var item = window.item = config.product;
      window._learnq.push(['track', 'Viewed Product', item]);
      window._learnq.push(['trackViewedItem', {
        Title: item.Name, ItemId: item.ProductID, Categories: item.Categories,
        ImageUrl: item.ImageURL, Url: item.URL,
        Metadata: { Brand: item.Brand, Price: item.Price, Value: item.Value, CompareAtPrice: item.CompareAtPrice },
        metafields: config.reviewMetafields || {}
      }]);
    }
    document.addEventListener('focusin', function (event) {
      if (event.target.closest('[data-newsletter-fallback],.raptor-newsletter-form,[class*="klaviyo-form-"]')) loadKlaviyo();
    });
  }
  if (clarityId) {
    window.clarity = window.clarity || function () {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };
    var previousConsent;
    function consent(marketing, analytics) {
      var choice = Boolean(marketing) + ":" + Boolean(analytics);
      if (choice === previousConsent) return;
      previousConsent = choice;
      window.clarity('consentv2', {
        ad_Storage: marketing ? 'granted' : 'denied',
        analytics_Storage: analytics ? 'granted' : 'denied', source: 101
      });
    }
    // Denied until Shopify supplies the current choice, including API failures.
    consent(false, false);
    document.addEventListener('visitorConsentCollected', function (event) {
      var choice = event.detail || {};
      consent(choice.marketingAllowed, choice.analyticsAllowed);
    });
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (error || !window.Shopify.customerPrivacy) return;
        var privacy = window.Shopify.customerPrivacy;
        consent(privacy.marketingAllowed(), privacy.analyticsProcessingAllowed());
      });
    }
  }
  function analytics() {
    loadKlaviyo();
    if (clarityId) load('clarity', 'https://www.clarity.ms/tag/' + clarityId + '?ref=shopify');
  }
  var scheduled = false;
  function painted() {
    if (scheduled) return;
    scheduled = true;
    // Allow the image and critical CSS to paint before analytics competes for CPU.
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        if (window.requestIdleCallback) window.requestIdleCallback(analytics, { timeout: 1500 });
        else window.setTimeout(analytics, 0);
      });
    });
  }
  function ready() {
    var hero = document.querySelector('.raptor-hero-media img, main img[fetchpriority="high"]');
    if (!hero || hero.complete) painted();
    else {
      hero.addEventListener('load', painted, { once: true });
      hero.addEventListener('error', painted, { once: true });
      window.setTimeout(painted, 8000); // Failed or stalled image must not disable apps.
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
})();
